import { Center as MantineCenter, CenterProps } from '@mantine/core';

export type ICenterProps = CenterProps;

/** @registry Design-layer pass-through over Mantine Center; import this instead of @mantine/core Center outside src/design. */
export const Center = MantineCenter;
